import { FC, memo } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Box from '@mui/material/Box';

import { Options, useOption } from 'lib';
import {
  OrderStatus_order$data,
  OrderStatus_order$key,
} from '__generated__/OrderStatus_order.graphql';

type Props = {
  order: OrderStatus_order$key;
};

export const optionsConfig: Options<OrderStatus_order$data['status']> = {
  draft: {
    label: 'Naujas',
    color: 'warning',
  },
  abandoned: {
    label: 'Paliktas krepšelis',
    color: 'warning',
  },
  pending: {
    label: 'Laukiama apmokėjimo',
    color: 'info',
  },
  advance: {
    label: 'Avansas',
    color: 'warning',
  },
  paid: {
    label: 'Apmokėtas',
    color: 'success',
  },
  canceled: {
    label: 'Atšauktas',
    color: 'error',
  },
  trash: {
    label: 'Ištrintas',
    color: 'error',
  },
};

const OrderStatus: FC<Props> = ({ order }) => {
  const { status } = useFragment(
    graphql`
      fragment OrderStatus_order on Order {
        status
      }
    `,
    order
  );

  const { label, color } = useOption(status, optionsConfig);

  return <Box sx={{ color }}>{label}</Box>;
};

export default memo(OrderStatus);
